/* eslint-disable import/no-anonymous-default-export */
import React from 'react'
import { makeStyles } from '@material-ui/core'
const useStyles = makeStyles((theme) => ({
  profile: {
    borderRadius: '50px',
    [theme.breakpoints.up('md')]: {
      //
    },
    [theme.breakpoints.up('lg')]: {
      margin: '0px auto',
      cursor: 'pointer',
      width: '70px',
    },
  },
}))

export default ({ className, image, onClick, style = {}, profile }) => {
  const classes = useStyles()
  const renderClass = className ? `${className} ${classes.image}` : profile ? classes.profile : ''

  return <img src={image} style={style} alt="custom" className={renderClass} onClick={onClick} />
}
